import { h } from 'vue'
import FormItem from './form-item.vue'
import { getValueByPath, setValueByPathToVue, filters } from '../../../utils/index'
import { useTemplate, useBeforValueActions } from '../../../hooks/index'

export default {
  props: {
    item: Object,
    data: Object,
    formItemWidth: Number,
    compileSource: Object,
    dragHandle: String,
  },
  setup(props) {
    const { beforActions } = useBeforValueActions()
    const { getTemplateData, compileData } = useTemplate()
    const propsItem = props.item
    // useItemWidth  --->  在不配置label的情况下是否设置宽度与formItem一致
    //labelTip --->  在label后显示提示信息, 也可以直接使用item中的title字段
    //renderFormItem ---> 在不配置label的情况下是否渲染formItem（需要校验时需要渲染formItem）
    //event ---> 事件
    const {
      beforValueAction,
      changeBorthers,
      colNum = 1,
      useItemWidth = false,
      labelTip,
      labelWidth,
      renderFormItem,
      event,
      ...parameter
    } = propsItem.parameter ?? {}
    let itemWidth = !props.formItemWidth ? 'auto' : colNum * props.formItemWidth
    if (props.formItemWidth && props.formItemWidth <= 1) {
      itemWidth = filters(itemWidth, 'percent')
    } else if (props.formItemWidth && props.formItemWidth > 1) {
      itemWidth += 'px'
    }

    //支持配置formItem的style
    const { itemStyle, ...style } = propsItem.style ?? {}
    const { labelStyle, ...itemStyleP } = itemStyle ?? {}

    return () => {
      console.log('item-render')
      let formItemRef = null

      const propsCompileData = getTemplateData(null, props.compileSource)
      //当设置不显示或者显示表达式为false时不渲染
      if (
        !propsItem.visible ||
        (propsItem.show && !compileData(propsItem.show, propsCompileData))
      ) {
        return null
      }
      //当没有改字段时渲染formItem会报错
      if (
        (propsItem.label || renderFormItem) &&
        /\./.test(propsItem.property) &&
        getValueByPath(props.data, propsItem.property.replace(/.(?=[^.]*$)(.+)/, ''), 'null') ===
          'null'
      ) {
        setValueByPathToVue(props.data, propsItem.property, null)
      }
      const childProps = compileData(parameter, propsCompileData)
      //如果配置【是否禁止编辑】为是则不允许编辑
      if (propsItem.disabled) {
        childProps.disabled = propsItem.disabled
      }

      const componentVNode = h(propsItem.componentCode, {
        style: !useItemWidth ? style : { width: itemWidth, ...style },
        attrs: { value: getValueByPath(props.data, propsItem.property), ...childProps },
        on: {
          input: (val) => {
            beforActions({
              val,
              beforValueAction: compileData(beforValueAction, propsCompileData),
              field: propsItem.property,
              callback(resVal) {
                setValueByPathToVue(props.data, propsItem.property, resVal)
                if (changeBorthers) {
                  const temp = {}
                  Object.keys(changeBorthers).forEach((im) => {
                    let otherFields = changeBorthers[im]
                    if (!otherFields) {
                      temp[im] = otherFields
                    } else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
                      temp[im] = compileData(otherFields, propsCompileData)
                    } else {
                      temp[im] = getValueByPath(resVal, otherFields)
                    }
                  })
                  Object.keys(temp).forEach((im) => {
                    setValueByPathToVue(props.data, im, temp[im])
                  })
                }
                //兼容老组件库，设值完之后触发校验
                if (formItemRef && !propsItem.componentCode.startsWith('Pg')) {
                  formItemRef.componentInstance.formItemsChange()
                }
              },
            })
          },
          ...event,
        },
      })
      if (!propsItem.label && !renderFormItem) {
        return componentVNode
      } else {
        formItemRef = h(
          FormItem,
          {
            attrs: {
              dragHandle: props.dragHandle,
              labelTip: labelTip ?? propsItem.title,
              labelWidth: labelWidth ? labelWidth : !propsItem.label ? '0' : undefined,
              label: propsItem.label,
              prop: propsItem.property,
              rules: propsItem.validators,
              labelStyle,
            },
            style: { width: itemWidth, ...itemStyleP },
          },
          [componentVNode]
        )
        return formItemRef
      }
    }
  },
}
